import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import './App.css';
import { Master } from './componentes/master/Master';
import 'antd/dist/antd.css';
import ScrollHandler from './componentes/master/ScrollHandler';



function App() {
  return (
    <div className="App">
      <Router>
      <ScrollHandler />
        <Route path="/" component={Master} />
      </Router>
    </div>
    
  );
}

export default App;
